// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var ref = allVue.ref;
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * @hidden
 */

var CollectionConfigurationVue2 = {
  name: 'KendoCollectionConfiguration',
  props: {
    chartKey: String,
    parentKey: String,
    parentStore: Object
  },
  provide: function provide() {
    return {
      childOption: false,
      chartCollection: this.$props.chartKey,
      parentKey: this.$props.parentKey,
      child: this.child,
      addChild: this.addChild,
      removeChild: this.removeChild
    };
  },
  inject: {
    dispatchOptions: {
      default: null
    },
    observersStore: {
      default: null
    },
    childrenObserver: {
      default: null
    }
  },
  created: function created() {
    var dispatchOptions = this.dispatchOptions;
    dispatchOptions({
      chartKey: this.$props.chartKey,
      payload: []
    });
  },
  data: function data() {
    return {
      child: {
        collection: []
      }
    };
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlots = getDefaultSlots(this);
    return h("div", [defaultSlots, " "]);
  },
  methods: {
    addChild: function addChild(item) {
      this.child.collection.push(item);
    },
    removeChild: function removeChild(item) {
      var index = this.child.collection.findIndex(function (ch) {
        return ch.uid === item.uid;
      });
      this.child.collection.splice(index, 1);
    }
  }
};
/**
 * @hidden
 */

var CollectionConfiguration = CollectionConfigurationVue2;
export { CollectionConfiguration, CollectionConfigurationVue2 };